<template>
  <div class="w-100" id="EditarMultipleAcuerdoClientes">

    <Button
      :size="15"
      color="#33BDFF"
      colorText="#ffffff"
      tooltip="Editar Múltiples"
      icon="fas fa-edit"
      round
      :width="30"
      class="mt-2 mb-3 mr-2"
      @click.native="editarMultiple();"
      translate
    />
    <ui-modal
      ref="modal"
      title="Editar Múltiple Acuerdos Clientes"
      class="modal-editar-simple-acuerdo-linea w-100"
      @close="ActionSetZindexTablaModal(false)"
    >

      <div class="w-100" id="editarMultipleAcuerdoLineasModal">
          <data-table-acuerdos-clientes
            customHeaders
            :headers="headers"
            :data="dataAux"
            idtabla="listado_confirmar_seleccionados1"
            :formulario="true"
            :acciones="[]"
            :load="load"
            :filtroColdtreatment="filtroColdtreatment"
          />
      </div>
      <!-- Footer -->
      <div class="d-flex justify-content-between mt-2">
        <button class="btn btn-default" @click="closeModal('modal')">
          Cerrar
        </button>
        <button class="btn btn-outline-warning" @click="editar()" id="buttonRefEditarAcuerdoLineas">
          Actualizar
        </button>
      </div>
    </ui-modal>
  </div>
</template>

<script>
// Common
import { mapActions, mapState } from "vuex";
import { 
  getAcuerdosClientesBaseByIds, 
  editarAcuerdoBaseClientes 
} from "@/constants/lineas";
import DataTableAcuerdosClientes from "../../../../dataTables/tarifas/DataTableAcuerdosClientes.vue";

import Button from "../../../../common/Button";

export default {
  
  props:["acuerdoClientesArreglo","data","limpiarChecks","getListaAcuerdosClientes","vaciarCliente","filtroColdtreatment"],

  data() {
    return {
      dataAux: this.data,
      load : true ,
      headers:[
        { title: "N°", width: "20px" },
        { title: "Cliente", width: "40px" },
        { title: "Naviera", width: "40px" },
        { title: "Naviera Salida", width: "40px" },
        { title: "POL", width: "50px" },
        { title: "POD", width: "30px" },
        { title: "Desde", width: "50px" },
        { title: "Hasta", width: "50px" },
        { title: "Vigencia", width: "100px" },
        { title: "TT", width: "20px" },
        { title: "Pública (Venta)", width: "10px" },
        { title: "Neta Cte Base", width: "10px" },
        { title: "Margen Com.", width: "10px" },
        { title: "Neta Cte.", width: "10px" },
        { title: "Descuento", width: "10px" },
        { title: "Unidad", width: "90px" },
        { title: "Commodity", width: "90px" },
        { title: "Atmósfera", width: "35px" },
        { title: "Trat. frío", width: "35px" },
        { title: "Dias Libres Origen", width: "10px" },
        { title: "Dias Plug Origen", width: "10px" },
        { title: "Dias Libres Destino", width: "10px" },
        { title: "Dias Plug Destino", width: "10px" },
        { title: "Genset", width: "2px" },
        { title: "Get Out", width: "2px" },
        { title: "Comentarios", width: "300px" },
        { title: "Tipo Contrato", width: "70px" },
        { title: "Contrato - Número", width: "70px" },
      ]
    };
  },
  methods: {
    ...mapActions(["ActionsSetShowModalAcuerdoLineasClienteBase"]),
    ...mapActions("lineas", ["actionSetDataListarTarifasAcuerdosClientesBase"]),
    ...mapActions(["ActionSetZindexTablaModal"]),
    
    estadoButton(text, estado = true) {
      let buttonRef = document.querySelector("#buttonRefEditarAcuerdoLineas");
      buttonRef.innerHTML = text;
      buttonRef.disabled = estado;
    },
    async editar(){

      this.dataAux.forEach( element => {
        const { cliente_id,naviera,pod,pol,from_date,
        to_date,vigencia, container_id,products_category_id,
        atmosphere_id,comment,commercial_margin } = element ;

        if( cliente_id.id === undefined || cliente_id.id === "" ){
          return this.$vToastify.error(
            "Campo Cliente requerido",
            "¡Error!"
          );
        }

        if( naviera.id === undefined || naviera.id === "" ){
          return this.$vToastify.error(
            "Campo Naviera requerido",
            "¡Error!"
          );
        }

        if( pod.id === undefined || pod.id === "" ){
          return this.$vToastify.error(
            "Campo POD requerido",
            "¡Error!"
          );
        }

        if( pol.id === undefined || pol.id === "" ){
          return this.$vToastify.error(
            "Campo POL requerido",
            "¡Error!"
          );
        }

        if( from_date === undefined || from_date === "" ){
          return this.$vToastify.error(
            "Campo Desde requerido",
            "¡Error!"
          );
        }

        if( to_date === undefined || to_date === "" ){
          return this.$vToastify.error(
            "Campo Hasta requerido",
            "¡Error!"
          );
        }

        if( vigencia === undefined || vigencia === "" ){
          return this.$vToastify.error(
            "Campo Vigencia requerido",
            "¡Error!"
          );
        }

        if( commercial_margin === undefined || commercial_margin === "" ){
          return this.$vToastify.error(
            "Campo Margen Com. requerido",
            "¡Error!"
          );
        }

        if( container_id.id === undefined || container_id.id === "" ){
          return this.$vToastify.error(
            "Campo Unidad requerido",
            "¡Error!"
          );
        }

        if( products_category_id.id === undefined || products_category_id.id === "" ){
          return this.$vToastify.error(
            "Campo Commodity requerido",
            "¡Error!"
          );
        }

        if( atmosphere_id.id === undefined || atmosphere_id.id === "" ){
          return this.$vToastify.error(
            "Campo Atmósfera requerido",
            "¡Error!"
          );
        }

        if( comment === undefined || comment === "" ){
          return this.$vToastify.error(
            "Campo Margen requerido",
            "¡Error!"
          );
        }

      });

      const form = {
        tariff_clients: this.dataAux.map(
          ({ id,cliente_id,naviera,pod,pol,from_date,
          to_date,vigencia,margin, container_id,products_category_id,
          atmosphere_id,coldtreatment,genset, comment, commercial_margin}) => {
          return {
            id,
            cliente_id:cliente_id.id, 
            naviera : naviera.id,
            pod: pod.id,
            pol: pol.id,
            from_date,
            to_date,
            vigencia,
            margin, 
            container_id: container_id.id,
            products_category_id: products_category_id.id,
            atmosphere_id: atmosphere_id.id,
            coldtreatment: typeof coldtreatment === "object" ? (coldtreatment.name || "") : (coldtreatment || ""),
            genset, 
            comment,
            commercial_margin
          };
        }) 
      }

      this.estadoButton("Actualizando...");

      this.$vToastify.loader("Realizando Solicitud...");

      try {
        
        await editarAcuerdoBaseClientes( form ) ;
        await this.getListaAcuerdosClientes( );
        this.$vToastify.stopLoader();
        this.estadoButton("Actualizar", false);
        this.limpiarChecks() ;
        this.closeModal('modal');

        this.$vToastify.success(
          "Acuerdo de Cliente Bases seleccionados actualizados correctamente",
          "¡Realizado!"
        );
      } catch (error) {
        this.$vToastify.stopLoader();
        this.estadoButton("Actualizar", false);

        return this.$vToastify.error(
          "Error al editar acuerdos clientes base, intente más tarde.",
          "¡Error!"
        );
      }
    },
    async editarMultiple(){

      if (this.acuerdoClientesArreglo.length === 0) {

        return this.$vToastify.warning(
          "Debe seleccionar registros para editar.",
          "!Precaución¡"
        );

      }

      this.load = true ;

      this.openModal('modal')  ;

      try {
        const { data_table } = await getAcuerdosClientesBaseByIds( this.acuerdoClientesArreglo ) ;

        this.dataAux = data_table.map(al => (
            {
              id: al.data_complementaria.id,
              cliente_id: {
                id: al.data_complementaria.cliente_id.id,
                name: al.data_complementaria.cliente_id.name
              },
              naviera: {
                id: al.data_complementaria.naviera_id.id,
                name: al.data_complementaria.naviera_id.name
              },
              naviera_salida: al.data[2],
              pod: {
                id: al.data_complementaria.pod.id,
                name: al.data_complementaria.pod.name
              },
              pol: {
                id: al.data_complementaria.pol.id,
                name: al.data_complementaria.pol.name
              },
              commercial_margin: al.data_complementaria.commercial_margin,
              margin: al.data_complementaria.margin,
              neta_cliente: al.data_complementaria.neta_cliente,
              from_date: al.data_complementaria.from_date,
              to_date: al.data_complementaria.to_date,
              transit_time: al.data_complementaria.transit_time,
              neta: al.data_complementaria.neta,
              public_value: al.data_complementaria.public_value,
              vigencia: al.data_complementaria.vigencia,
              container_id: {
                id: parseInt(al.data_complementaria.container_id.id),
                name: al.data_complementaria.container_id.name
              },
              products_category_id: {
                id: parseInt(al.data_complementaria.products_category_id.id),
                name: al.data_complementaria.products_category_id.name
              },
              descuento: parseInt(al.data_complementaria.public_value) - parseInt(al.data_complementaria.neta),
              atmosphere_id: {
                id: parseInt(al.data_complementaria.atmosphere_id.id) ?? "",
                name: al.data_complementaria.atmosphere_id.name ?? ""
              },
              coldtreatment: al.data_complementaria.coldtreatment && al.data_complementaria.coldtreatment !== "-"
                ? {
                    id: al.data_complementaria.coldtreatment_id || "",
                    name: al.data_complementaria.coldtreatment
                  }
                : { id: "", name: "" },
              free_days_embark: al.data_complementaria.free_days_embark,
              plug_days_embark: al.data_complementaria.plug_days_embark,
              free_days_land: al.data_complementaria.free_days_land,
              plug_days_land: al.data_complementaria.plug_days_land,
              genset: al.data_complementaria.genset === "Si",
              get_out: al.data_complementaria.get_out,
              comment: al.data_complementaria.comment,
              tipo_contrato_id: {
                id: al.data_complementaria.tipo_contrato.id,
                name: al.data_complementaria.tipo_contrato.name
              },
              tariff_contract: al.data_complementaria.id_contrato
            }
          )
        );

        this.load = false ;

      } catch (error) {

        this.load = false ;

        return this.$vToastify.error(
          "Error al obtener registros, recargue la página y vuelva a intentar",
          "¡Error!"
        );

      }
    },
    openModal(ref) {
      this.ActionSetZindexTablaModal(true);
      this.$refs[ref].open();
    },
    closeModal(ref) {
      this.$refs[ref].close();
    },
    cerrarModal() {
      //this.ActionSetZindexModal(false);
    },
  },
  computed: {
    ...mapState(["showAcuerdoLineasClienteBase"]),
    
  },
  components: {
    Button,
    DataTableAcuerdosClientes
  },
  watch: {

  },
};
</script>

<style>
#EditarMultipleAcuerdoClientes .ui-modal__container{
  width: 100%;
}
</style>
